export default __webpack_public_path__ + "static/media/cat-029-starter-systems_.c022c25f.svg";